import {GET_COMPANIES_IN_STOCK_EXCHANGE} from 'graphql/queries/stocks';
import {kycStatusEnums} from 'utils/mock';

const {useLazyQuery, useQuery} = require('@apollo/client');
const {DatePicker, Form, Select} = require('antd');
const {
  GET_ASSET_CLASS_INSTRUMENTS,
} = require('graphql/queries/assetManagement');
const {GET_ALL_CAMPAIGNS} = require('graphql/queries/campaign');
const {
  GET_ALL_COUNTRIES,
  GET_ALL_RISK_PROFILES,
} = require('graphql/queries/users');
const {useState, useEffect} = require('react');
const {toast} = require('react-toastify');
const {
  notificationOrderStatusOptions,
  usersSegments,
  notificationAssetClasses,
} = require('utils/constants');
import _ from 'lodash';
import styles from './popupAnnouncement.module.scss';
import {UserSelectFormField} from 'components/userSelectField/UserSelectFormField';

export const StepTwoAnnouncement = ({form, isEdit = false, defaultUserIds}) => {
  const [stocks, setStocks] = useState([]);
  const [instruments, setInstruments] = useState([]);
  const instrumentKey = Form.useWatch('instrumentKeys', form);

  const {Option} = Select;

  const {data, loading} = useQuery(GET_ALL_COUNTRIES, {
    errorPolicy: 'all',
    onError: error => toast.error(error?.message),
  });
  const [
    fetchInstruments,
    {refetch: refetchInstrument, loading: loadingInstruments},
  ] = useLazyQuery(GET_ASSET_CLASS_INSTRUMENTS, {
    notifyOnNetworkStatusChange: true,
    onError: error => toast.error(error?.message),
  });

  const {data: allRiskProfiles, loading: loadingRiskProfiles} = useQuery(
    GET_ALL_RISK_PROFILES,
    {
      errorPolicy: 'all',
      onError: error => toast.error(error?.message),
    },
  );

  const {data: allCampaigns, loading: loadingCampaigns} = useQuery(
    GET_ALL_CAMPAIGNS,
    {
      errorPolicy: 'all',
      onError: error => toast.error(error?.message),
    },
  );

  const [fetchStocks, {refetch: refetchStocks, loading: loadingStocks}] =
    useLazyQuery(GET_COMPANIES_IN_STOCK_EXCHANGE, {
      errorPolicy: 'all',
      notifyOnNetworkStatusChange: true,
      onError: error => toast.error(error?.message),
    });

  useEffect(() => {
    if (instrumentKey?.find(key => ['BOND', 'MUTUAL_FUND'].includes(key))) {
      form.setFieldValue('assetId', undefined);
      fetchInstruments({
        variables: {
          input: {
            explore: false,
            instrumentKey: instrumentKey?.find(key => key === 'BOND')
              ? 'BOND'
              : 'MUTUAL_FUND',
            assetClassKey: instrumentKey?.find(key => key === 'BOND')
              ? 'FIXED_INCOMES'
              : 'FUNDS',
          },
        },
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true,
        onError: error => toast.error(error?.message),
        onCompleted: data =>
          setInstruments(data?.getFinancialInstruments?.data || []),
      });
    } else if (instrumentKey?.find(key => key === 'STOCK')) {
      form.setFieldValue('assetId', undefined);
      fetchStocks({
        variables: {
          stockExchangeCode: 'BRVM',
          page: 1,
          limit: 200,
        },
        onCompleted: data =>
          setStocks(data?.adminGetStockExchangeListedCompanies?.companies),
        onError: error => toast.error(error?.message),
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'no-cache',
      });
    }
  }, [instrumentKey]);

  const handleSearchStocks = _.debounce(async value => {
    try {
      const {data} = await refetchStocks({
        searchTerm: value,
        page: 1,
        limit: 20,
      });
      setStocks(data?.adminGetStockExchangeListedCompanies?.companies || []);
    } catch (error) {
      console.error('Error fetching stocks:', error);
    }
  }, 1200);

  const handleSearch = _.debounce(async value => {
    try {
      const {data} = await refetchInstrument({
        input: {
          explore: false,
          instrumentKey: instrumentKey[0],
          assetClassKey: instrumentKey?.find(key => key === 'BOND')
            ? 'FIXED_INCOMES'
            : 'FUNDS',
          search: value,
          page: 1,
          limit: 100,
        },
      });

      setInstruments(data.getFinancialInstruments?.data || []);
    } catch (error) {
      console.error('Error fetching instruments:', error);
    }
  }, 1200);

  return (
    <div style={{padding: '15px'}}>
      {!isEdit && (
        <>
          <h2>Target Audience</h2>
          <p>Select the target audience for the popup</p>
        </>
      )}
      <div>
        <Form.Item
          className={styles.fieldWidth}
          name="userIds"
          label="Specific Users"
          tooltip="Search and select individual users to target. Leave empty to target everyone matching the filters below.">
          <UserSelectFormField
            placeholder="Search and select user(s)"
            defaultUsers={defaultUserIds}
          />
        </Form.Item>
        <Form.Item
          className={styles.fieldWidth}
          name="riskProfiles"
          label="Risk Profiles">
          <Select
            mode="multiple"
            allowClear
            loading={loadingRiskProfiles}
            showSearch
            optionFilterProp="filter"
            filterOption={false}>
            {allRiskProfiles?.getAllRiskProfiles?.data?.map(data => (
              <Option key={data.id}>{data.name}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          className={styles.fieldWidth}
          name="userSegments"
          label="User Segments">
          <Select mode="multiple" allowClear>
            {usersSegments.map(data => (
              <Option key={data.key}>{data.value}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="countryCodes"
          label="Select Countries"
          className={styles.fieldWidth}>
          <Select
            loading={loading}
            optionFilterProp="filter"
            mode="multiple"
            placeholder="Select Countries"
            allowClear>
            {data?.getAllCountries?.map(data => (
              <Option filter={data?.name} key={data?.countryCode}>
                <div className="all-data">
                  <img src={data?.icon} alt="" />
                  <span>{data?.name}</span>
                </div>
              </Option>
            ))}
          </Select>
        </Form.Item>
        <h2>KYC Filters Statuses</h2>
        <Form.Item
          name="identityCheck"
          label="Identity Check Statuses"
          className={styles.fieldWidth}>
          <Select mode="multiple" placeholder="KYC Statuses" allowClear>
            {kycStatusEnums.map(({label, value}) => (
              <Option key={value}>{label}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="documentCheck"
          label="Document Check Statuses"
          className={styles.fieldWidth}>
          <Select mode="multiple" placeholder="KYC Statuses" allowClear>
            {kycStatusEnums.map(({label, value}) => (
              <Option key={value}>{label}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="amlCheck"
          label="AML Check Statuses"
          className={styles.fieldWidth}>
          <Select mode="multiple" placeholder="KYC Statuses" allowClear>
            {kycStatusEnums.map(({label, value}) => (
              <Option key={value}>{label}</Option>
            ))}
          </Select>
        </Form.Item>
        <div className={styles.dateFields}>
          <Form.Item name="signupStartDate" label="Signup (Start Date)">
            <DatePicker showTime allowClear />
          </Form.Item>
          <Form.Item name="signupEndDate" label="Signup (End Date)">
            <DatePicker showTime allowClear />
          </Form.Item>
        </div>
        <div className={styles.dateFields}>
          <Form.Item
            name="lastAppVisitedStartDate"
            label="Last App Visited (Start Date)">
            <DatePicker showTime allowClear />
          </Form.Item>
          <Form.Item
            name="lastAppVisitedEndDate"
            label="Last App Visited (End Date)">
            <DatePicker showTime allowClear />
          </Form.Item>
        </div>

        <h2>Investment Audience</h2>
        <Form.Item
          className={styles.fieldWidth}
          name="instrumentKeys"
          label="Select Asset(s)">
          <Select mode="multiple" placeholder="Bond" allowClear>
            {notificationAssetClasses.map(option => (
              <Select.Option key={option.key}>{option.name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        {instrumentKey?.find(key => ['VENTURE', 'IPO'].includes(key)) && (
          <Form.Item
            className={styles.fieldWidth}
            name="ventureAssetId"
            label="Select Venture / IPO">
            <Select
              filterOption={true}
              optionFilterProp="filter"
              allowClear
              showSearch
              loading={loadingCampaigns}
              placeholder="Search and Select">
              {allCampaigns?.getAllCampaigns?.campaigns
                ?.filter(
                  data =>
                    data?.campaignMode === 'LIVE' &&
                    data?.campaignStatus !== 'DRAFT',
                )
                ?.map(data => (
                  <Option
                    filter={data?.fundraisingCompany?.companyName}
                    key={data?.id}>
                    <div className={styles['option-data']}>
                      <div className="all-data">
                        <img
                          src={data?.fundraisingCompany?.logoImgURL}
                          alt=""
                        />
                        <span>{data?.fundraisingCompany?.companyName}</span>
                      </div>
                      <div>--{data?.campaignStatus}</div>
                    </div>
                  </Option>
                ))}
            </Select>
          </Form.Item>
        )}
        {instrumentKey?.find(key => ['BOND', 'MUTUAL_FUND'].includes(key)) && (
          <Form.Item
            className={styles.fieldWidth}
            name="audienceInstrumentId"
            label="Instrument based on Selected Asset">
            <Select
              showSearch
              onSearch={handleSearch}
              filterOption={false}
              placeholder="Search for Instrument"
              loading={loadingInstruments}
              allowClear>
              {instruments?.map(instrument => (
                <Select.Option key={instrument?.id}>
                  {instrument?.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
        {instrumentKey?.find(key => key === 'STOCK') && (
          <Form.Item
            className={styles.fieldWidth}
            name="stockId"
            label="Search & Select Stock">
            <Select
              onSearch={handleSearchStocks}
              loading={loadingStocks}
              allowClear
              showSearch
              filterOption={false}
              placeholder="Search for Stock">
              {stocks?.map(stock => (
                <Select.Option key={stock?.company?.id}>
                  {stock?.company?.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
        <Form.Item
          className={styles.fieldWidth}
          name="directions"
          label="Order Direction">
          <Select mode="multiple" placeholder="Buy" allowClear showSearch>
            <Select.Option key="BUY">Buy</Select.Option>
            <Select.Option key="SELL">Sell</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          className={styles.fieldWidth}
          name="statuses"
          label="Order Status(es)">
          <Select mode="multiple" placeholder="Open" allowClear showSearch>
            {notificationOrderStatusOptions.map(option => (
              <Select.Option key={option.key}>{option.name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <div className={styles.dateFields}>
          <Form.Item name="investmentStartDate" label="Investment Start Date">
            <DatePicker showTime />
          </Form.Item>
          <Form.Item name="investmentEndDate" label="Investment End Date">
            <DatePicker showTime />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};
